module.exports = __webpack_public_path__ + "04_very_short_gold.aa6d43ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_very_short_gold.png
// module id = BKR9
// module chunks = 0